import { TRAIL_SOURCE, SMOOTH_MOVE_FRAMES, SMOOTH_MOVE_INTERVAL_MS } from '../utils/map-constants.js'

export class TrailRenderer {
  constructor() {
    this.map = null
    this.followedMonitorId = null
    this.followedEntityType = null  // MARKERS-DESIGN-SPEC §6: estilo por tipo
    this.trailCoords = []
    this.animationCounters = new Map()
  }

  init(map) { this.map = map }

  follow(monitorId, currentCoords, entityType) {
    this.followedMonitorId = monitorId
    this.followedEntityType = entityType || 'device'
    this.trailCoords = [currentCoords]
    this._updateTrailSource()
  }

  unfollow() {
    this.followedMonitorId = null
    this.followedEntityType = null
    this.trailCoords = []
    this._updateTrailSource()
  }

  extendTrail(newCoords) {
    if (!this.followedMonitorId) return
    this.trailCoords.push(newCoords)
    if (this.trailCoords.length > 500) this.trailCoords = this.trailCoords.slice(-500)
    this._updateTrailSource()
  }

  loadHistory(positions) {
    this.trailCoords = positions.map(function(p) { return [p.longitude, p.latitude] })
    this._updateTrailSource()
  }

  smoothMove(monitorId, oldCoords, newCoords, onFrame) {
    var counter = (this.animationCounters.get(monitorId) || 0) + 1
    this.animationCounters.set(monitorId, counter)

    var oldLng = oldCoords[0], oldLat = oldCoords[1]
    var dLng = (newCoords[0] - oldLng) / SMOOTH_MOVE_FRAMES
    var dLat = (newCoords[1] - oldLat) / SMOOTH_MOVE_FRAMES
    var self = this

    return new Promise(function(resolve) {
      var frame = 0
      function step() {
        if (self.animationCounters.get(monitorId) !== counter) { resolve(); return }
        frame++
        var lng = oldLng + dLng * frame
        var lat = oldLat + dLat * frame
        onFrame([lng, lat])
        if (monitorId === self.followedMonitorId && frame === SMOOTH_MOVE_FRAMES) {
          self.extendTrail([lng, lat])
        }
        if (frame < SMOOTH_MOVE_FRAMES) {
          setTimeout(step, SMOOTH_MOVE_INTERVAL_MS)
        } else {
          resolve()
        }
      }
      step()
    })
  }

  _updateTrailSource() {
    if (!this.map) return
    var source = this.map.getSource(TRAIL_SOURCE)
    if (!source) return
    // entityType en las properties dispara el filter en las layers de
    // trail — una layer distinta por tipo (device/sos_call/reportant) con
    // paint dedicado. Ver MARKERS-DESIGN-SPEC §6 + layer-manager.addTrailLayers.
    var entityType = this.followedEntityType || 'device'
    var features = []
    if (this.trailCoords.length >= 2) {
      features.push({
        type: 'Feature',
        geometry: { type: 'LineString', coordinates: this.trailCoords },
        properties: { entityType: entityType },
      })
    }
    for (var i = 0; i < this.trailCoords.length; i++) {
      features.push({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: this.trailCoords[i] },
        properties: { entityType: entityType },
      })
    }
    source.setData({ type: 'FeatureCollection', features: features })
  }
}
